import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const dataItemWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x3,
  borderRadius: themeVars.radius.sm,
  minWidth: 150,
});

export const dataItemLabelClass = style({
  fontSize: themeVars.font.size.textSm,
  color: themeVars.colors.neutrals.grey60,
});

export const dataItemValueClass = style({
  fontSize: themeVars.font.size.textMd,
  fontWeight: themeVars.font.weight.bold,
  color: themeVars.colors.neutrals.black100,
});
